import * as Types from './sectionsActionTypes';

export function getSections() {
  return { type: Types.GET_SECTIONS };
}

export function getSectionsSuccess(sections) {
  return { type: Types.GET_SECTIONS_SUCCESS, sections };
}

export function getSectionsFailure(error) {
  return { type: Types.GET_SECTIONS_FAILURE, error };
}

export function getSection(id) {
  return { type: Types.GET_SECTION, id };
}

export function getSectionSuccess(section) {
  return { type: Types.GET_SECTION_SUCCESS, section };
}

export function getSectionFailure(error) {
  return { type: Types.GET_SECTION_FAILURE, error };
}

export function getSectionAndStart(id) {
  return { type: Types.GET_SECTION_AND_START, id };
}



// WEBPACK FOOTER //
// ./src/redux/actions/sectionsActions.js